export default "__VITE_ASSET__981d7485__"